import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";
import CTLBooleanCell from "application/components/CTLBooleanCell";


const operationURLS = {
  list: "/systemConfiguration/list",
  update: "systemConfiguration/create",
  register: "systemConfiguration/create",
  delete: "/systemConfiguration/delete",
};

const getColumns = (onDelete,onEdit) => {
  return [
    {
      Header: "Disposition Url",
      accessor: "postCallDispositionUrl",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      validation: formControl.string().required("Required"),
      width: 12,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
        Header: "Previewdialing Mode",
        accessor: "previewDialingMode",
        displayInList: true,
        allowInForm: true,
        allowFilter: false,
        dataType: "integer",
        width: 6,
        validation: formControl.string().digitsOnly(),
        Cell: ({ value }) => <DefaultCell value={value} />,
      }, {
        Header: "Realtime Callcenter Days",
        accessor: "realtimeDataDaysCallCenter",
        displayInList: true,
        allowInForm: true,
        allowFilter: false,
        dataType: "integer",
        width: 6,
        validation: formControl.string().digitsOnly(),
        Cell: ({ value }) => <DefaultCell value={value} />,
      }, {
        Header: "CallCenter Agent Mode",
        accessor: "callCenterAgentMode",
        displayInList: true,
        allowInForm: true,
        allowFilter: false,
        dataType: "integer",
        width: 6,
        validation: formControl.string().digitsOnly(),
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "Agent Activity",
        accessor: "startAgentActivity",
        displayInList: true,
        allowInForm: true,
        allowFilter: false,
        dataType: "boolean",
        controlType:'checkbox',
        width: 6,
        Cell: ({ value }) => <CTLBooleanCell value={value} />,
      },
      {
        Header: "Agent Sync Servers",
        accessor: "startAgentSyncAcrossServers",
        displayInList: true,
        allowInForm: true,
        allowFilter: false,
        dataType: "boolean",
        controlType:'checkbox',
        width: 6,
        Cell: ({ value }) => <CTLBooleanCell value={value} />,
      },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];
};

export { getColumns, operationURLS };
